import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Simplesearch from '@/components/Simplesearch';
import Advancesearch from '@/components/Advancesearch';
import Otros from '@/components/Otros';
import Contacto from '@/components/Contacto';
import Company from '@/components/Company';
import CompanyOTT from '@/components/CompanyOTT';
import Ott from '@/components/Ott';
import VueMoment from 'vue-moment';

import VueResource from 'vue-resource';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Meta from 'vue-meta';

const moment = require('moment');

require('moment/locale/en-gb');
require('moment/locale/es');

Vue.use(require('vue-moment'), {
    moment,
});

Vue.use(Router);
Vue.use(VueResource);

Vue.use(require('vue-router'));
// Vue.use(axios);
Vue.use(Meta);

Vue.mixin({
    methods: {
        redirectTo: async function(recordID, module) {
            if (recordID) {
                this.$router.push({ path: '/' + module + '/' + recordID });
            }
        },
        setDateFormat1ByLanguage(lang, date) {
            //this.$moment().locale(lang)
            //console.log(moment(date).format("dddd, DD [de] MMMM YYYY"))
            return this.$moment(date).format('dddd, DD [de] MMMM YYYY');
        },
        setDateFormatEnglish(date) {
            //this.$moment().locale('en')
            //console.log(this.$moment.locale('en'))
            //console.log(moment(date).format("dddd, DD [de] MMMM YYYY"))
            return this.$moment(date).format('ddd DD MMM, YYYY');
        },
        getVerticalContact(arrayImages, isHorizontal = false) {
            if (arrayImages) {
                var tmpCont = JSON.parse(arrayImages);
                if (tmpCont) {
                    for (var i = 0; i < tmpCont.length; i++) {
                        if (tmpCont[i].Version == 'Vertical' && !isHorizontal) {
                            return (
                                ('url("https://images.produ.com/ww/' +
                                tmpCont[i].Subfolder
                                    ? tmpCont[i].Subfolder + '/'
                                    : '') +
                                (tmpCont[i].path ? tmpCont[i].path : '' + '")')
                            );
                        } else if (
                            tmpCont[i].Version == 'Horizontal' &&
                            isHorizontal
                        ) {
                            var url =
                                (tmpCont[i].Subfolder
                                    ? tmpCont[i].Subfolder + '/'
                                    : '') +
                                (tmpCont[i].path ? tmpCont[i].path : '');
                            url =
                                'url("https://images.produ.com/ww/' +
                                url +
                                '")';
                            return url;
                        }
                    }
                    return (
                        (tmpCont[0].Subfolder
                            ? tmpCont[0].Subfolder + '/'
                            : '') + (tmpCont[0].path ? tmpCont[0].path : '')
                    );
                }
            }
        },
        getCategoria: function(id) {
            var cat;
            if (id == 30288 || id == 103896) {
                cat = 'Compradores';
            } else if (id == 37071 || id == 170010) {
                cat = 'Productores';
            } else if (id == 28015 || id == 83312) {
                cat = 'Distribuidores';
            } else if (id == 70234 || id == 1771 || id == 54570) {
                cat = 'Dobladores';
            } else if (id == 23731 || id == 59912) {
                cat = 'Ingenieros';
            }
            return cat;
        },
        redirectConsulta: function(nombre, guiaOtt) {
            var textName = nombre.split('|');
            var result =
                parseInt(textName[1]) > 0
                    ? guiaOtt == 1
                        ? 'empresaOTT'
                        : 'empresa'
                    : 'contacto';
            return result;
        },
        capitalizeFirstLetter: function(string) {
            return (
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
            );
        },
        getNameOtt: function(string, id) {
            var texto;
            if (id == 7) {
                texto = 'tecnologia-ott-vod';
            } else if (id == 8) {
                texto = 'servicios-publicidad-produccion-mercadeo';
            } else {
                texto = string
                    .trim()
                    .replace(' y', '')
                    .replace(',', '-')
                    .replace(' &', '')
                    .replace(' ', '-')
                    .toLowerCase();
            }
            return texto;
        },
        checkMobile: function() {
            var check = false;
            (function(a) {
                if (
                    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                        a
                    ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                        a.substr(0, 4)
                    )
                )
                    check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        },
        getFirstImg: function(arrayImages) {
            if (arrayImages && typeof arrayImages !== 'undefined') {
                var tmpCont = JSON.parse(arrayImages);
                if (tmpCont && typeof tmpCont !== 'undefined') {
                    return tmpCont[0].Subfolder + '/' + tmpCont[0].path;
                }
            }
            return '';
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        loadJqueryNavheader: function() {
            (function($) {
                'use strict';

                var bootsnav = {
                    initialize: function() {
                        this.event();
                        this.hoverDropdown();
                        this.navbarSticky();
                        this.navbarScrollspy();
                    },
                    event: function() {
                        // ------------------------------------------------------------------------------ //
                        // Variable
                        // ------------------------------------------------------------------------------ //
                        var getNav = $('nav.navbar.bootsnav');

                        // ------------------------------------------------------------------------------ //
                        // Navbar Sticky
                        // ------------------------------------------------------------------------------ //
                        var navSticky = getNav.hasClass('navbar-sticky');
                        if (navSticky) {
                            // Wraped navigation
                            getNav.wrap("<div class='wrap-sticky'></div>");
                        }

                        // ------------------------------------------------------------------------------ //
                        // Navbar Center
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('brand-center')) {
                            var postsArr = new Array(),
                                index = $('nav.brand-center'),
                                $postsList = index.find('ul.navbar-nav');

                            index.prepend(
                                "<span class='storage-name' style='display:none;'></span>"
                            );

                            //Create array of all posts in lists
                            index.find('ul.navbar-nav > li').each(function() {
                                if ($(this).hasClass('active')) {
                                    var getElement = $('a', this)
                                        .eq(0)
                                        .text();
                                    $('.storage-name').html(getElement);
                                }
                                postsArr.push($(this).html());
                            });

                            //Split the array at this point. The original array is altered.
                            var firstList = postsArr.splice(
                                    0,
                                    Math.round(postsArr.length / 2)
                                ),
                                secondList = postsArr,
                                ListHTML = '';

                            var createHTML = function(list) {
                                ListHTML = '';
                                for (var i = 0; i < list.length; i++) {
                                    ListHTML += '<li>' + list[i] + '</li>';
                                }
                            };

                            //Generate HTML for first list
                            createHTML(firstList);
                            $postsList.html(ListHTML);
                            index
                                .find('ul.nav')
                                .first()
                                .addClass('navbar-left');

                            //Generate HTML for second list
                            createHTML(secondList);
                            //Create new list after original one
                            $postsList
                                .after('<ul class="nav navbar-nav"></ul>')
                                .next()
                                .html(ListHTML);
                            index
                                .find('ul.nav')
                                .last()
                                .addClass('navbar-right');

                            //Wrap navigation menu
                            index
                                .find('ul.nav.navbar-left')
                                .wrap("<div class='col-half left'></div>");
                            index
                                .find('ul.nav.navbar-right')
                                .wrap("<div class='col-half right'></div>");

                            //Selection Class
                            index.find('ul.navbar-nav > li').each(function() {
                                var dropDown = $('ul.dropdown-menu', this),
                                    megaMenu = $('ul.megamenu-content', this);
                                dropDown.closest('li').addClass('dropdown');
                                megaMenu.closest('li').addClass('megamenu-fw');
                            });

                            var getName = $('.storage-name').html();
                            if (!getName == '') {
                                $(
                                    "ul.navbar-nav > li:contains('" +
                                        getName +
                                        "')"
                                ).addClass('active');
                            }
                        }

                        // ------------------------------------------------------------------------------ //
                        // Navbar Sidebar
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('navbar-sidebar')) {
                            // Add Class to body
                            $('body').addClass('wrap-nav-sidebar');
                            getNav.wrapInner("<div class='scroller'></div>");
                        } else {
                            $('.bootsnav').addClass('on');
                        }

                        // ------------------------------------------------------------------------------ //
                        // Menu Center
                        // ------------------------------------------------------------------------------ //
                        if (getNav.find('ul.nav').hasClass('navbar-center')) {
                            getNav.addClass('menu-center');
                        }

                        // ------------------------------------------------------------------------------ //
                        // Navbar Full
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('navbar-full')) {
                            // Add Class to body
                            $('nav.navbar.bootsnav')
                                .find('ul.nav')
                                .wrap("<div class='wrap-full-menu'></div>");
                            $('.wrap-full-menu').wrap(
                                "<div class='nav-full'></div>"
                            );
                            $('ul.nav.navbar-nav').prepend(
                                "<li class='close-full-menu'><a href='#'><i class='fa fa-times'></i></a></li>"
                            );
                        } else if (getNav.hasClass('navbar-mobile')) {
                            getNav.removeClass('no-full');
                        } else {
                            getNav.addClass('no-full');
                        }

                        // ------------------------------------------------------------------------------ //
                        // Navbar Mobile
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('navbar-mobile')) {
                            // Add Class to body
                            $('.navbar-collapse').on(
                                'shown.bs.collapse',
                                function() {
                                    $('body').addClass('side-right');
                                }
                            );
                            $('.navbar-collapse').on(
                                'hide.bs.collapse',
                                function() {
                                    $('body').removeClass('side-right');
                                }
                            );

                            $(window).on('resize', function() {
                                $('body').removeClass('side-right');
                            });
                        }

                        // ------------------------------------------------------------------------------ //
                        // Navbar Fixed
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('no-background')) {
                            $(window).on('scroll', function() {
                                var scrollTop = $(window).scrollTop();
                                if (scrollTop > 34) {
                                    $('.navbar-fixed').removeClass(
                                        'no-background'
                                    );
                                } else {
                                    $('.navbar-fixed').addClass(
                                        'no-background'
                                    );
                                }
                            });
                        }

                        // ------------------------------------------------------------------------------ //
                        // Navbar Fixed
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('navbar-transparent')) {
                            $(window).on('scroll', function() {
                                var scrollTop = $(window).scrollTop();
                                if (scrollTop > 34) {
                                    $('.navbar-fixed').removeClass(
                                        'navbar-transparent'
                                    );
                                } else {
                                    $('.navbar-fixed').addClass(
                                        'navbar-transparent'
                                    );
                                }
                            });
                        }

                        // ------------------------------------------------------------------------------ //
                        // Button Cart
                        // ------------------------------------------------------------------------------ //
                        $('.btn-cart').on('click', function(e) {
                            e.stopPropagation();
                        });

                        // ------------------------------------------------------------------------------ //
                        // Toggle Search
                        // ------------------------------------------------------------------------------ //
                        $('nav.navbar.bootsnav .attr-nav').each(function() {
                            $('li.search > a', this).on('click', function(e) {
                                e.preventDefault();
                                $('.top-search').slideToggle();
                            });
                        });
                        $('.input-group-addon.close-search').on(
                            'click',
                            function() {
                                $('.top-search').slideUp();
                            }
                        );

                        // ------------------------------------------------------------------------------ //
                        // Toggle Side Menu
                        // ------------------------------------------------------------------------------ //
                        $('nav.navbar.bootsnav .attr-nav').each(function() {
                            $('li.side-menu > a', this).on('click', function(
                                e
                            ) {
                                e.preventDefault();
                                $('nav.navbar.bootsnav > .side').toggleClass(
                                    'on'
                                );
                                $('body').toggleClass('on-side');
                            });
                        });
                        $('.side .close-side').on('click', function(e) {
                            e.preventDefault();
                            $('nav.navbar.bootsnav > .side').removeClass('on');
                            $('body').removeClass('on-side');
                        });

                        // ------------------------------------------------------------------------------ //
                        // Wrapper
                        // ------------------------------------------------------------------------------ //
                        $('body').wrapInner("<div class='wrapper'></div>");
                    },

                    // ------------------------------------------------------------------------------ //
                    // Change dropdown to hover on dekstop
                    // ------------------------------------------------------------------------------ //
                    hoverDropdown: function() {
                        var getNav = $('nav.navbar.bootsnav'),
                            getWindow = $(window).width(),
                            getHeight = $(window).height(),
                            getIn = getNav.find('ul.nav').data('in'),
                            getOut = getNav.find('ul.nav').data('out');

                        if (getWindow < 991) {
                            // Height of scroll navigation sidebar
                            $('.scroller').css('height', 'auto');

                            // Disable mouseenter event
                            $('nav.navbar.bootsnav ul.nav')
                                .find('li.dropdown')
                                .off('mouseenter');
                            $('nav.navbar.bootsnav ul.nav')
                                .find('li.dropdown')
                                .off('mouseleave');
                            $('nav.navbar.bootsnav ul.nav')
                                .find('.title')
                                .off('mouseenter');
                            $('nav.navbar.bootsnav ul.nav').off('mouseleave');
                            $('.navbar-collapse').removeClass('animated');

                            // Enable click event
                            $('nav.navbar.bootsnav ul.nav').each(function() {
                                $('.dropdown-menu', this).addClass('animated');
                                $('.dropdown-menu', this).removeClass(getOut);

                                // Dropdown Fade Toggle
                                $('a.dropdown-toggle', this).off('click');
                                $('a.dropdown-toggle', this).on(
                                    'click',
                                    function(e) {
                                        e.stopPropagation();
                                        $(this)
                                            .closest('li.dropdown')
                                            .find('.dropdown-menu')
                                            .first()
                                            .stop()
                                            .fadeToggle()
                                            .toggleClass(getIn);
                                        $(this)
                                            .closest('li.dropdown')
                                            .first()
                                            .toggleClass('on');
                                        return false;
                                    }
                                );

                                // Hidden dropdown action
                                $('li.dropdown', this).each(function() {
                                    $(this)
                                        .find('.dropdown-menu')
                                        .stop()
                                        .fadeOut();
                                    $(this).on(
                                        'hidden.bs.dropdown',
                                        function() {
                                            $(this)
                                                .find('.dropdown-menu')
                                                .stop()
                                                .fadeOut();
                                        }
                                    );
                                    return false;
                                });

                                // Megamenu style
                                $('.megamenu-fw', this).each(function() {
                                    $('.col-menu', this).each(function() {
                                        $('.content', this).addClass(
                                            'animated'
                                        );
                                        $('.content', this)
                                            .stop()
                                            .fadeOut();
                                        $('.title', this).off('click');
                                        $('.title', this).on(
                                            'click',
                                            function() {
                                                $(this)
                                                    .closest('.col-menu')
                                                    .find('.content')
                                                    .stop()
                                                    .fadeToggle()
                                                    .addClass(getIn);
                                                $(this)
                                                    .closest('.col-menu')
                                                    .toggleClass('on');
                                                return false;
                                            }
                                        );

                                        $('.content', this).on(
                                            'click',
                                            function(e) {
                                                e.stopPropagation();
                                            }
                                        );
                                    });
                                });
                            });

                            // Hidden dropdown
                            var cleanOpen = function() {
                                $('li.dropdown', this).removeClass('on');
                                $('.dropdown-menu', this)
                                    .stop()
                                    .fadeOut();
                                $('.dropdown-menu', this).removeClass(getIn);
                                $('.col-menu', this).removeClass('on');
                                $('.col-menu .content', this)
                                    .stop()
                                    .fadeOut();
                                $('.col-menu .content', this).removeClass(
                                    getIn
                                );
                            };

                            // Hidden om mouse leave
                            $('nav.navbar.bootsnav').on(
                                'mouseleave',
                                function() {
                                    cleanOpen();
                                }
                            );

                            // Enable click atribute navigation
                            $('nav.navbar.bootsnav .attr-nav').each(function() {
                                $('.dropdown-menu', this).removeClass(
                                    'animated'
                                );
                                $('li.dropdown', this).off('mouseenter');
                                $('li.dropdown', this).off('mouseleave');
                                $('a.dropdown-toggle', this).off('click');
                                $('a.dropdown-toggle', this).on(
                                    'click',
                                    function(e) {
                                        e.stopPropagation();
                                        $(this)
                                            .closest('li.dropdown')
                                            .find('.dropdown-menu')
                                            .first()
                                            .stop()
                                            .fadeToggle();
                                        $('.navbar-toggle').each(function() {
                                            $('.fa', this).removeClass(
                                                'fa-times'
                                            );
                                            $('.fa', this).addClass('fa-bars');
                                            $('.navbar-collapse').removeClass(
                                                'in'
                                            );
                                            $('.navbar-collapse').removeClass(
                                                'on'
                                            );
                                        });
                                    }
                                );

                                $(this).on('mouseleave', function() {
                                    $('.dropdown-menu', this)
                                        .stop()
                                        .fadeOut();
                                    $('li.dropdown', this).removeClass('on');
                                    return false;
                                });
                            });

                            // Toggle Bars
                            $('.navbar-toggle').each(function() {
                                $(this).off('click');
                                $(this).on('click', function() {
                                    $('.fa', this).toggleClass('fa-bars');
                                    $('.fa', this).toggleClass('fa-times');
                                    cleanOpen();
                                });
                            });
                        } else if (getWindow > 991) {
                            // Height of scroll navigation sidebar
                            $('.scroller').css('height', getHeight + 'px');

                            // Navbar Sidebar
                            if (getNav.hasClass('navbar-sidebar')) {
                                // Hover effect Sidebar Menu
                                $('nav.navbar.bootsnav ul.nav').each(
                                    function() {
                                        $('a.dropdown-toggle', this).off(
                                            'click'
                                        );
                                        $('a.dropdown-toggle', this).on(
                                            'click',
                                            function(e) {
                                                e.stopPropagation();
                                            }
                                        );

                                        $('.dropdown-menu', this).addClass(
                                            'animated'
                                        );
                                        $('li.dropdown', this).on(
                                            'mouseenter',
                                            function() {
                                                $('.dropdown-menu', this)
                                                    .eq(0)
                                                    .removeClass(getOut);
                                                $('.dropdown-menu', this)
                                                    .eq(0)
                                                    .stop()
                                                    .fadeIn()
                                                    .addClass(getIn);
                                                $(this).addClass('on');
                                                return false;
                                            }
                                        );

                                        $('.col-menu').each(function() {
                                            $('.content', this).addClass(
                                                'animated'
                                            );
                                            $('.title', this).on(
                                                'mouseenter',
                                                function() {
                                                    $(this)
                                                        .closest('.col-menu')
                                                        .find('.content')
                                                        .stop()
                                                        .fadeIn()
                                                        .addClass(getIn);
                                                    $(this)
                                                        .closest('.col-menu')
                                                        .addClass('on');
                                                    return false;
                                                }
                                            );
                                        });

                                        $(this).on('mouseleave', function() {
                                            $('.dropdown-menu', this)
                                                .stop()
                                                .removeClass(getIn);
                                            $('.dropdown-menu', this)
                                                .stop()
                                                .addClass(getOut)
                                                .fadeOut();
                                            $('.col-menu', this)
                                                .find('.content')
                                                .stop()
                                                .fadeOut()
                                                .removeClass(getIn);
                                            $('.col-menu', this).removeClass(
                                                'on'
                                            );
                                            $('li.dropdown', this).removeClass(
                                                'on'
                                            );
                                            return false;
                                        });
                                    }
                                );
                            } else {
                                // Hover effect Default Menu
                                $('nav.navbar.bootsnav ul.nav').each(
                                    function() {
                                        $('a.dropdown-toggle', this).off(
                                            'click'
                                        );
                                        $('a.dropdown-toggle', this).on(
                                            'click',
                                            function(e) {
                                                e.stopPropagation();
                                            }
                                        );

                                        $('.megamenu-fw', this).each(
                                            function() {
                                                $('.title', this).off('click');
                                                $(
                                                    'a.dropdown-toggle',
                                                    this
                                                ).off('click');
                                                $('.content').removeClass(
                                                    'animated'
                                                );
                                            }
                                        );

                                        $('.dropdown-menu', this).addClass(
                                            'animated'
                                        );
                                        $('li.dropdown', this).on(
                                            'mouseenter',
                                            function() {
                                                $('.dropdown-menu', this)
                                                    .eq(0)
                                                    .removeClass(getOut);
                                                $('.dropdown-menu', this)
                                                    .eq(0)
                                                    .stop()
                                                    .fadeIn()
                                                    .addClass(getIn);
                                                $(this).addClass('on');
                                                return false;
                                            }
                                        );

                                        $('li.dropdown', this).on(
                                            'mouseleave',
                                            function() {
                                                $('.dropdown-menu', this)
                                                    .eq(0)
                                                    .removeClass(getIn);
                                                $('.dropdown-menu', this)
                                                    .eq(0)
                                                    .stop()
                                                    .fadeOut()
                                                    .addClass(getOut);
                                                $(this).removeClass('on');
                                            }
                                        );

                                        $(this).on('mouseleave', function() {
                                            $(
                                                '.dropdown-menu',
                                                this
                                            ).removeClass(getIn);
                                            $('.dropdown-menu', this)
                                                .eq(0)
                                                .stop()
                                                .fadeOut()
                                                .addClass(getOut);
                                            $('li.dropdown', this).removeClass(
                                                'on'
                                            );
                                            return false;
                                        });
                                    }
                                );
                            }

                            // ------------------------------------------------------------------------------ //
                            // Hover effect Atribute Navigation
                            // ------------------------------------------------------------------------------ //
                            $('nav.navbar.bootsnav .attr-nav').each(function() {
                                $('a.dropdown-toggle', this).off('click');
                                $('a.dropdown-toggle', this).on(
                                    'click',
                                    function(e) {
                                        e.stopPropagation();
                                    }
                                );

                                $('.dropdown-menu', this).addClass('animated');
                                $('li.dropdown', this).on(
                                    'mouseenter',
                                    function() {
                                        $('.dropdown-menu', this)
                                            .eq(0)
                                            .removeClass(getOut);
                                        $('.dropdown-menu', this)
                                            .eq(0)
                                            .stop()
                                            .fadeIn()
                                            .addClass(getIn);
                                        $(this).addClass('on');
                                        return false;
                                    }
                                );

                                $('li.dropdown', this).on(
                                    'mouseleave',
                                    function() {
                                        $('.dropdown-menu', this)
                                            .eq(0)
                                            .removeClass(getIn);
                                        $('.dropdown-menu', this)
                                            .eq(0)
                                            .stop()
                                            .fadeOut()
                                            .addClass(getOut);
                                        $(this).removeClass('on');
                                    }
                                );

                                $(this).on('mouseleave', function() {
                                    $('.dropdown-menu', this).removeClass(
                                        getIn
                                    );
                                    $('.dropdown-menu', this)
                                        .eq(0)
                                        .stop()
                                        .fadeOut()
                                        .addClass(getOut);
                                    $('li.dropdown', this).removeClass('on');
                                    return false;
                                });
                            });
                        }

                        // ------------------------------------------------------------------------------ //
                        // Menu Fullscreen
                        // ------------------------------------------------------------------------------ //
                        if (getNav.hasClass('navbar-full')) {
                            var windowHeight = $(window).height(),
                                windowWidth = $(window).width();

                            $('.nav-full').css('height', windowHeight + 'px');
                            $('.wrap-full-menu').css(
                                'height',
                                windowHeight + 'px'
                            );
                            $('.wrap-full-menu').css(
                                'width',
                                windowWidth + 'px'
                            );

                            $('.navbar-collapse').addClass('animated');
                            $('.navbar-toggle').each(function() {
                                var getId = $(this).data('target');
                                $(this).off('click');
                                $(this).on('click', function(e) {
                                    e.preventDefault();
                                    $(getId).removeClass(getOut);
                                    $(getId).addClass('in');
                                    $(getId).addClass(getIn);
                                    return false;
                                });

                                $('li.close-full-menu').on('click', function(
                                    e
                                ) {
                                    e.preventDefault();
                                    $(getId).addClass(getOut);
                                    setTimeout(function() {
                                        $(getId).removeClass('in');
                                        $(getId).removeClass(getIn);
                                    }, 500);
                                    return false;
                                });
                            });
                        }
                    },

                    // ------------------------------------------------------------------------------ //
                    // Navbar Sticky
                    // ------------------------------------------------------------------------------ //
                    navbarSticky: function() {
                        var getNav = $('nav.navbar.bootsnav'),
                            navSticky = getNav.hasClass('navbar-sticky');

                        if (navSticky) {
                            // Set Height Navigation
                            var getHeight = getNav.height();
                            $('.wrap-sticky').height(getHeight);

                            // Windown on scroll
                            var getOffset = $('.wrap-sticky').offset().top;
                            $(window).on('scroll', function() {
                                var scrollTop = $(window).scrollTop();
                                if (scrollTop > getOffset) {
                                    getNav.addClass('sticked');
                                } else {
                                    getNav.removeClass('sticked');
                                }
                            });
                        }
                    },

                    // ------------------------------------------------------------------------------ //
                    // Navbar Scrollspy
                    // ------------------------------------------------------------------------------ //
                    navbarScrollspy: function() {
                        var navScrollSpy = $('.navbar-scrollspy'),
                            $body = $('body'),
                            getNav = $('nav.navbar.bootsnav'),
                            offset = getNav.outerHeight();

                        if (navScrollSpy.length) {
                            $body.scrollspy({
                                target: '.navbar',
                                offset: offset,
                            });

                            // Animation Scrollspy
                            $('.scroll').on('click', function(event) {
                                event.preventDefault();

                                // Active link
                                $('.scroll').removeClass('active');
                                $(this).addClass('active');

                                // Remove navbar collapse
                                $('.navbar-collapse').removeClass('in');

                                // Toggle Bars
                                $('.navbar-toggle').each(function() {
                                    $('.fa', this).removeClass('fa-times');
                                    $('.fa', this).addClass('fa-bars');
                                });

                                // Scroll
                                var scrollTop = $(window).scrollTop(),
                                    $anchor = $(this).find('a'),
                                    $section = $($anchor.attr('href')).offset()
                                        .top,
                                    $window = $(window).width(),
                                    $minusDesktop = getNav.data(
                                        'minus-value-desktop'
                                    ),
                                    $minusMobile = getNav.data(
                                        'minus-value-mobile'
                                    ),
                                    $speed = getNav.data('speed');

                                if ($window > 992) {
                                    var $position = $section - $minusDesktop;
                                } else {
                                    var $position = $section - $minusMobile;
                                }

                                $('html, body')
                                    .stop()
                                    .animate(
                                        {
                                            scrollTop: $position,
                                        },
                                        $speed
                                    );
                            });

                            // Activate Navigation
                            var fixSpy = function() {
                                var data = $body.data('bs.scrollspy');
                                if (data) {
                                    offset = getNav.outerHeight();
                                    data.options.offset = offset;
                                    $body.data('bs.scrollspy', data);
                                    $body.scrollspy('refresh');
                                }
                            };

                            // Activate Navigation on resize
                            var resizeTimer;
                            $(window).on('resize', function() {
                                clearTimeout(resizeTimer);
                                var resizeTimer = setTimeout(fixSpy, 200);
                            });
                        }
                    },
                };

                // Initialize
                $(document).ready(function() {
                    bootsnav.initialize();
                });

                // Reset on resize
                $(window).on('resize', function() {
                    bootsnav.hoverDropdown();
                    setTimeout(function() {
                        bootsnav.navbarSticky();
                    }, 500);

                    // Toggle Bars
                    $('.navbar-toggle').each(function() {
                        $('.fa', this).removeClass('fa-times');
                        $('.fa', this).addClass('fa-bars');
                        $(this).removeClass('fixed');
                    });
                    $('.navbar-collapse').removeClass('in');
                    $('.navbar-collapse').removeClass('on');
                    $('.navbar-collapse').removeClass('bounceIn');
                });
            })(jQuery);
        },
    },
});

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                title:
                    'PRODU | Whoiswho | Ejecutivos de la industria del entretenimiento',
            },
        },
        {
            path: '/busqueda',
            name: 'Search',
            component: Simplesearch,
            meta: {
                title:
                    'PRODU | Whoiswho | Ejecutivos de la industria del entretenimiento',
            },
        },
        {
            path: '/advancesearch/:search/',
            name: 'Advancesearch',
            component: Advancesearch,
            meta: {
                title:
                    'PRODU | Whoiswho | Ejecutivos de la industria del entretenimiento',
            },
        },
        {
            path: '/contacto/:contacto/',
            name: 'Contacto',
            component: Contacto,
            meta: {
                title:
                    'PRODU | Whoiswho | Ejecutivos de la industria del entretenimiento',
            },
        },
        {
            path: '/empresa/:empresa/',
            name: 'Company',
            component: Company,
            meta: {
                title:
                    'PRODU | Whoiswho | Ejecutivos de la industria del entretenimiento',
            },
        },
        {
            name: 'Compradores',
            path: '/Compradores',
            component: Otros,
            props: true,
            meta: {
                title: 'PRODU | Whoiswho | Compradores de contenido',
            },
        },
        {
            name: 'Distribuidores',
            path: '/Distribuidores',
            component: Otros,
            props: true,
            meta: {
                title: 'PRODU | Whoiswho | Distribuidores de contenido',
            },
        },
        {
            name: 'Productores',
            path: '/Productores',
            component: Otros,
            props: true,
            meta: {
                title: 'PRODU | Whoiswho | Productores de contenido',
            },
        },
        {
            name: 'Dobladores',
            path: '/Dobladores',
            component: Otros,
            props: true,
            meta: {
                title: 'PRODU | Whoiswho | Dobladores de contenido',
            },
        },
        {
            name: 'Ingenieros',
            path: '/Ingenieros',
            component: Otros,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'servicios-ott',
            path: '/servicios-ott',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'digital-channels',
            path: '/digital-channels',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'telcos-cableoperadores',
            path: '/telcos-cableoperadores',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'programadores-locales',
            path: '/programadores-locales',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'programadores-regionales',
            path: '/programadores-regionales',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'distribuidores-agregadores',
            path: '/distribuidores-agregadores',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'tecnologia-ott-vod',
            path: '/tecnologia-ott-vod',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            name: 'servicios-publicidad-produccion-mercadeo',
            path: '/servicios-publicidad-produccion-mercadeo',
            component: Ott,
            props: true,
            meta: {
                title:
                    'PRODU | Whoiswho | Ingenieros industria del entretenimiento',
            },
        },
        {
            path: '/empresaOTT/:empresa/',
            name: 'CompanyOTT',
            component: CompanyOTT,
            meta: {
                title:
                    'PRODU | Whoiswho | Ejecutivos de la industria del entretenimiento',
            },
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js